module.exports = new __parcel__URL__("status.b00914cb.svg").toString();